import 'react-app-polyfill/stable';
import React from 'react';
import ReactDom from 'react-dom';
import App, { SpotiDataType } from './components/App';
import * as Sentry from '@sentry/react';

import '@spotify-internal/landing-page-library/esm/styles/masthead/index.css';
import '@spotify-internal/landing-page-library/esm/styles/encore-light-theme/encore-light-theme.css';

type Props = SpotiDataType & { baseElement: HTMLElement };

const main = (data: Props) => {
  const { environment, release, useErrorReporting, ...appProps } = data;

  Sentry.init({
    dsn: 'https://09d927c146bb46728e7b701c2122e066@o22381.ingest.sentry.io/6303532',
    sampleRate: 0.2,
    environment: environment,
    release: release,
    beforeSend: event => (useErrorReporting ? event : null),
    ignoreErrors: [/(Time to paint|navigationTiming) api is not supported/gim],
    allowUrls: [/(spotify\.(com|net))|(scdn\.co)|(spotifycdn\.com)/gim],
  });

  const baseElement = document.getElementById('spoti-root');
  const app = <App baseElement={baseElement!} {...appProps} />;

  ReactDom.hydrate(app, baseElement);
};

main(window.SPOTI_DATA);
